import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-paper border-t border-ink">
      <div className="frame py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="flex items-center gap-3 label-muted">
            <span aria-hidden className="relative block w-5 h-5 bg-ink">
              <span className="absolute inset-[3px] bg-lime"></span>
            </span>
            © {currentYear} Charliecollc. All rights reserved.
          </div>

          {/* Legal links */}
          <div className="flex items-center gap-6">
            <Link to="/terms" className="link-underline label hover:text-accent">
              Terms of Service
            </Link>
            <Link to="/privacy" className="link-underline label hover:text-accent">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
